import { isNotEmpty, isTruthy, normalizeSlug } from 'utility/functions';
import { RawResponse, SportNewsDto, SportNewsItem } from 'lib/ssr/sport/news/types';
import { parse } from 'node-html-parser';

export { ssrNews } from './ssr';

export const toNewsSlug = (slug?: string): string => {
  let result = '';

  if (isTruthy(slug?.length)) {
    result = normalizeSlug(
      slug!
        .split('/')
        .filter((x, idx) => idx > 0 && isNotEmpty(x))
        .join('/'),
      true
    );
  }

  // console.log(`toNewsSlug("${slug}") -> "${result}"`)

  return result;
};

export const toNewsModel = (items: RawResponse): SportNewsDto =>
  (items ?? []).map(({ link, title, category, ...oth }, idx) => {
    const doc = parse(oth.description);
    const p = doc.querySelector('p');
    const img = doc.querySelector('img');

    const description = p?.textContent ?? '';

    let thumbnail = (img?.outerHTML ?? '').replace(
      /(class|style|loading)\s?=\s?('|")?(\w|\s|-|:|;|\%)*('|")?\s?/gim,
      ''
    );

    if (idx > 8) {
      thumbnail = thumbnail.replace('>', 'loading="async">');
    }

    return {
      link,
      title,
      category,
      thumbnail,
      description,
    } as SportNewsItem;
  });